<template>
  <div>
    <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w" style="min-height: 100px;" v-loading="getData" element-loading-background="rgba(0, 0, 0, 0.4)">
      <div class="po-r pt10 pb20 w100 tx-c" v-if="appData">
        <span class="font-18">{{ appData.name }}</span>
        <div class="in-block po-a font-0 btn-collect" v-loading="collecting">
          <el-button type="success" round v-if="$route.query.id == 'obj_5626fbaf2af04809a2475184578085ce'" @click="showCarList">查看未来7天可用车辆信息</el-button>
          <el-button size="mini" round @click="clickCollect(appData.isCollect)">
            <i class="yellow" :class="appData.isCollect ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
            {{ appData.isCollect ? '取消收藏' : '点击收藏' }}
          </el-button>
          <el-button type="warning" v-if="awsUrl == ''" round @click="newAws" :loading="gettingUrl">我要发起</el-button>
          <a class="aws-btn mr10" v-else round :href="awsUrl" target="_blank">我要发起</a>
          <el-button type="primary" round @click="refreshTab" :loading="gettingUrl">刷新</el-button>
        </div>
      </div>
      <section>
        <el-tabs type="card" v-model="showKey">
          <el-tab-pane lazy v-for="(item, index) in workData" :key="index" :label="item.name" :name="item.id">
            <ServerInfoTab :ref="`tab` + item.id" v-if="item.component == 'ServerInfoTab'" :has-url="awsUrl" :get-url="item.getUrl" :get-id="item.id" :label="item.label" :process-def-id="item.processDefId" @show-aws="showAws" />
            <ServerInfoTabYFB :ref="`tab` + item.id" v-if="item.component == 'ServerInfoTabYFB'" :has-url="awsUrl" @show-aws="showAws" />
            <ServerInfoCollect :ref="`tab` + item.id" v-if="item.component == 'ServerInfoCollect' && appData" :app-name="appData.name" />
          </el-tab-pane>
        </el-tabs>
      </section>
    </div>

    <!-- <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w" style="min-height: 100px;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.4)">
      <section v-if="appData">
        <p class="w100 pb20 tx-c font-18">业务说明</p>
        <div class="po-r w100 bor-t bor-l font-14 flex-box server-info" v-for="(item, index) in msgData" :key="index">
          <div style="flex: 1;" v-for="(val, key) in item" :key="key">
            <div class="h100 flex-box">
              <div class="h100 pt20 pb20 pl20 pr20 bor-r tx-c flex-1">{{ val.label }}</div>
              <div class="h100 pt20 pb20 pl20 pr20 bor-r flex-5">
                <span v-if="val.label != '评分情况'" v-html="val.content"></span>
                <el-rate v-else :value="val.content / 2" allow-half disabled></el-rate>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="w100 tx-c" v-if="error == 404">
        <el-button @click="error = 0, fetchAppData()">网络请求错误，点击重新获取</el-button>
      </div>
    </div> -->

    <!-- <div class="aws-window-fix" v-show="isShowAws"></div>
    <div class="aws-window" v-show="isShowAws">
      <el-button class="off-aws" icon="el-icon-close" @click="hideAws" circle></el-button>
      <iframe id="awsWindow" v-if="awsUrl != ''" :src="awsUrl"></iframe>
    </div> -->

    <el-dialog title="" :visible.sync="isShowAws" width="1000px" top="10px" :close-on-click-modal="false" @closed="reload">
      <div class="po-r w100" style="height: calc(100vh - 75px);">
        <iframe class="w100 h100 po-r" style="border: none;" id="awsWindow" ref="awsWindow" v-if="isShowAws != ''" :src="awsUrl"></iframe>
      </div>

      <ProcessDialog ref="processDialog" />
    </el-dialog>

    <CarSevenDay ref="carSevenDay" v-if="$route.query.id == 'obj_5626fbaf2af04809a2475184578085ce'" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ServerInfoTab from "@/components/ServerInfoTab";
import ServerInfoTabYFB from "@/components/ServerInfoTabYFB";
import ServerInfoCollect from "@/components/ServerInfoCollect";
import CarSevenDay from "@/components/ServeInfo/CarSevenDay";

import ProcessDialog from "@/components/Public/ProcessDialog";

export default {
  name: "server_info",
  components: {
    ServerInfoTab,
    ServerInfoTabYFB,
    ServerInfoCollect,
    CarSevenDay,
    ProcessDialog,
  },
  data() {
    return {

      loading: false,
      error: 0,
      errorMsg: "",
      appData: null,

      collecting: false,

      showKey: this.$route.query.showkey ? this.$route.query.showkey : "DB",
      getData: false,
      workData: [
        {
          component: "ServerInfoTab",
          id: "DB",
          name: "待办记录",
          getUrl: "task/findTaskPage",
          processDefId: this.$route.query.id,
        },
        {
          component: "ServerInfoTab",
          id: "YBJL",
          name: "已办记录",
          getUrl: "task/findTaskHisPage",
          processDefId: this.$route.query.id,
        },
        {
          component: "ServerInfoTabYFB",
          id: "YFB",
          name: "我的发布",
        },
        {
          component: "ServerInfoCollect",
          id: "PJ",
          name: "评价",
          processDefId: this.$route.query.id,
        },
      ],

      isShowAws: false,
      gettingUrl: false,
      awsUrl: "",
    };
  },
  computed: {
    ...mapState(["userData"]),
    msgData() {
      let arr = [];
      if (this.appData && this.appData.main.length > 0) {
        let twoData = [];
        for (const item of this.appData.main) {
          // if (item.label == '评分情况') {
          //     item.content = item.content / 2;
          // }
          twoData = [...twoData, item];
          twoData.length == 2
            ? ((arr = [...arr, twoData]), (twoData = []))
            : null;
        }
      }
      return arr;
    },
  },
  created() {
    if (!this.$route.query.id || this.$route.query.id == "") {
      this.$notify({
        title: "错误",
        message: "请求参数出错",
        type: "error",
        offset: 60,
      });
      this.$router.push({ name: "home" });
    } else {
      this.fetchAppData();
    }
  },
  mounted() {
    this.getUrl();
    // if (this.showKey != "PJ") {
    //   const keyName = "tab" + this.showKey;
    //   this.$nextTick(() => {
    //     this.$refs[keyName][0].fetchData();
    //   });
    // }
  },
  methods: {
    fetchAppData() {
      this.loading = true;

      this.$http
        .post(
          `serve/findById`,
          this.$qs.stringify({
            id: this.$route.query.id,
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetStatus == 0 && data.RetCode) {
            this.appData = data.RetData;
            if (this.appData % 2 == 1) {
              this.appData.push({
                label: "",
                content: "",
              });
            }
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.error = 404;
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60,
          });

          this.loading = false;
        });
    },
    clickCollect(isTrue) {
      this.collecting = true;
      const URL = !isTrue ? `serveCollection/newCo` : `serveCollection/delCo`;
      this.$http
        .post(
          URL,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveId: this.$route.query.id,
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            this.appData.isCollect = !isTrue;
            this.$notify({
              title: "成功",
              message: data.resMsg,
              type: "success",
              offset: 60,
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60,
            });
          }
          this.collecting = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60,
          });
          this.collecting = false;
        });
    },
    getUrl() {
      this.$http
        .post(
          `awsPortal/getProcessUrl`,
          this.$qs.stringify({
            userId: this.userData.userId,
            processDefId: this.$route.query.id,
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.RetCode && data.RetStatus == 0) {
            this.awsUrl = data.RetData;
          }
        })
        .catch(() => {});
    },
    newAws() {
      this.gettingUrl = true;
      this.$http
        .post(
          `awsPortal/getAwsStartUrl`,
          this.$qs.stringify({
            processDefId: this.$route.query.id,
          })
        )
        .then(({ data }) => {
          if (data.RetCode && data.RetStatus == 0) {
            this.showAws(data.RetData);
          } else {
            this.$notify({
              title: "错误",
              message: data.RetMsg,
              type: "error",
              offset: 60,
            });
          }
          this.gettingUrl = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络断开，请检查网络",
            type: "error",
            offset: 60,
          });
          this.gettingUrl = false;
        });
    },
    showCarList() {
      this.$refs.carSevenDay.showList();
    },
    showAws(getUrl) {
      this.isShowAws = true;
      this.awsUrl = getUrl;

      this.$nextTick(() => {
        window.addEventListener("message", (e) => {
          if (e.data.iframeHide) {
            window.location.reload();
          } else if (e.data.act == "showRelatedProcess") {
            this.$refs.processDialog.showView(
              e.data.tprocessid,
              e.data.tCanEdit
            );
          }
        });

        this.$refs.awsWindow.onload = () => {
          const af =
            this.$refs.awsWindow.contentWindow["AWSFormMainAPI"] || undefined;
          if (af) {
            af.customCloseFormPage(() => {
              window.location.reload();
              return true;
            });
          }
        };
      });
    },
    refreshTab() {
      const keyName = "tab" + this.showKey;
      this.$refs[keyName][0].fetchData();
    },
    hideAws() {
      this.isShowAws = false;
      this.awsUrl = "";
      const keyName = "tab" + this.showKey;
      if (this.showKey != "DB") {
        this.$refs[keyName][0].fetchData();
      }
    },
    reload() {
      window.location.reload();
    },
  },
  watch: {
    showKey(value) {
      const keyName = "tab" + value;
      this.$nextTick(() => {
        this.$refs[keyName][0].fetchData();
      });
    },
  },
};
</script>

<style scoped>
.off-aws {
  position: absolute;
  right: -30px;
  top: -30px;
}

#awsWindow {
  border: none;
  position: relative;
  width: 100%;
  height: 100%;
}

.aws-window-fix {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 599;
}

.aws-window {
  position: fixed;
  left: 5%;
  top: 5%;
  width: 90%;
  height: 90%;
  background: #fff;
  z-index: 601;
}

.server-info:last-child:after {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: #ccc;
}

.btn-collect {
  right: 0;
  top: 50%;
  -webkit-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  transform: translate(0, -50%);
}

.aws-btn {
  margin-left: 10px;
  padding: 7px 15px;
  border-radius: 20px;
  font-size: 12px;
  display: inline-block;
  white-space: nowrap;
  background: #e6a23c;
  border: 1px solid #e6a23c;
  color: #fff;
  -webkit-appearance: none;
  text-align: center;
  outline: 0;
}
</style>
